import React from "react";
import { string } from "prop-types";

import { useStore } from "../../utilities/mobx/storeHooks";
import * as S from "./styled";

const HomeClaimCTAMinimal = ({ className }) => {
  const { store } = useStore();
  const { uiStore } = store;

  return (
    <S.CTAContainer className={className}>
      <S.CTAText>
        Is this your home? Get its estimated current market value.
      </S.CTAText>
      <S.ViewButton onClick={uiStore.openModal}>get home value</S.ViewButton>
    </S.CTAContainer>
  );
};

HomeClaimCTAMinimal.propTypes = {
  className: string
};

HomeClaimCTAMinimal.defaultProps = {
  className: ""
};

export default HomeClaimCTAMinimal;
